import { useState, useEffect } from 'react';
import { FindAccountPage } from './auth/FindAccountPage';
import { DesktopFindAccountPage } from './desktop/DesktopFindAccountPage';

export function ResponsiveFindAccountPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <FindAccountPage /> : <DesktopFindAccountPage />;
}